import React from 'react'

function Icon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="#22C55E" stroke-width="2"/>
        <path d="M7 12l3 3 7-7" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default Icon